import { Route, Switch, useRouteMatch } from 'react-router-dom';
import React from 'react';
import { TurnoverView } from './turnover.view';

export const TurnoverRouter = () => {
  let { path } = useRouteMatch();

  return (
    <div>
      <Switch>
        <Route exact path={path}>
          <TurnoverView />
        </Route>
      </Switch>
    </div>
  );
};
